export const routes = {
    login: "/login",
    register: "/register",
    users: "/users",
    profile: "/profile",
    forgotPassword: "/forgot_password",
    /** Главная — доска машин (features/board). */
    machines: "/machines",
    /** Подписка на оповещения MAX. */
    notifications: "/notifications",
    /** Эталоны параметров ЭБУ (features/ecu, S7). */
    references: "/references",
    /** Резервные копии БД и файлов (features/backup, S16). */
    backups: "/backups",
    /** Уехавшие машины и рабочее время по этапам (features/stats, S17.2). */
    stats: "/stats",
};
